// src/components/SiteFooter.js
import React from 'react';
import { Link } from 'react-router-dom';

const FOOTER_BG = '#0b0f0a';
const FOOTER_FG = 'rgba(229,231,235,0.75)';
const FOOTER_BORDER = 'rgba(255,255,255,0.06)';

const linkStyle = {
  color: FOOTER_FG,
  textDecoration: 'none',
  fontSize: 13,
  fontWeight: 500,
};

const sepStyle = {
  color: 'rgba(255,255,255,0.18)',
  fontSize: 12,
};

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        background: FOOTER_BG,
        borderTop: `1px solid ${FOOTER_BORDER}`,
        padding: '14px 16px',
        marginTop: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 10,
        position: 'relative',
        zIndex: 5,
      }}
    >
      <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 12 }}>
        © {year} MENVIO
      </div>

      <nav
        aria-label="Footer"
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 14,
          flexWrap: 'wrap',
        }}
      >
        <Link to="/impressum" style={linkStyle}>
          Impressum
        </Link>
        <span style={sepStyle} aria-hidden="true">·</span>
        <Link to="/datenschutz" style={linkStyle}>
          Datenschutz
        </Link>
        <span style={sepStyle} aria-hidden="true">·</span>
        <a
          href="https://www.menvio.ai"
          target="_blank"
          rel="noopener noreferrer"
          style={linkStyle}
        >
          www.menvio.ai
        </a>
      </nav>
    </footer>
  );
}
